(function () {
  var endpoint = 'https://mail-cebdwlkvzs.cn-hangzhou.fcapp.run/inquiry';
  var formSelector = 'form[data-oulai-inquiry-form]';
  var defaultContact = { key: 'jasmine', name: 'Jasmine', email: 'jasmine@ntoulai.com', phone: '+86 18012295285' };

  function clean(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
  function read(form, names) {
    for (var i = 0; i < names.length; i += 1) {
      var field = form.elements.namedItem(names[i]);
      if (field && clean(field.value)) return clean(field.value);
    }
    return '';
  }
  function contactKey(contact) {
    var value = clean(contact && (contact.key || contact.name || contact.email)).toLowerCase();
    if (value.indexOf('zhang') >= 0 || value === 'zh') return 'zhang';
    if (value.indexOf('catherine') >= 0) return 'catherine';
    return 'jasmine';
  }
  function assignedContact(form) {
    if (typeof window.__oulaiRefreshAssignedContacts === 'function') window.__oulaiRefreshAssignedContacts(form);
    if (typeof window.__oulaiGetAssignedContact === 'function') return window.__oulaiGetAssignedContact();
    return defaultContact;
  }
  function idempotencyKey(form) {
    var field = form.querySelector('[data-oulai-idempotency-field]');
    if (field && field.value) return field.value;
    var key = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    if (field) field.value = key;
    return key;
  }
  function setCopyStatus(form, status, message) {
    var field = form.querySelector('[data-oulai-copy-status-field]');
    var node = form.querySelector('[data-oulai-inquiry-status]');
    if (field) field.value = status;
    if (node) {
      node.hidden = false;
      node.textContent = message;
    }
  }
  function buildPayload(form) {
    var contact = assignedContact(form);
    return {
      idempotencyKey: idempotencyKey(form),
      salesKey: contactKey(contact),
      assignedSales: contact && contact.name ? contact.name : defaultContact.name,
      copyToInquiry: false,
      name: read(form, ['contact[Name]', 'contact[name]']),
      email: read(form, ['contact[email]']),
      phone: read(form, ['contact[Phone]', 'contact[Phone or WhatsApp]']),
      company: read(form, ['contact[Company]']),
      country: read(form, ['contact[Destination country]']),
      quantity: read(form, ['contact[Quantity]']),
      unit: read(form, ['contact[Unit]']),
      intent: read(form, ['contact[Order intent]']),
      product: read(form, ['contact[Product]']),
      productUrl: read(form, ['contact[Product URL]']),
      variantId: read(form, ['contact[Variant ID]']),
      sku: read(form, ['contact[SKU]']),
      specification: read(form, ['contact[Specification]']),
      message: read(form, ['contact[Requirements]']),
      pageUrl: window.location.href,
      source: 'Product inquiry form',
    };
  }
  function sendAssignedCopy(payload) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 6000);
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Idempotency-Key': payload.idempotencyKey },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined,
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (error) { data = { error: text }; }
        if (!response.ok || data.ok === false) throw new Error(data.error || data.detail || 'Assigned copy failed.');
        return data;
      });
    }).finally(function () { window.clearTimeout(timer); });
  }
  function continueNativeSubmit(form, submitter) {
    form.dataset.oulaiNativeSubmit = 'true';
    if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
    else form.submit();
  }
  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches || !form.matches(formSelector)) return;
    if (form.dataset.oulaiNativeSubmit === 'true') return;
    if (!form.checkValidity()) return;
    event.preventDefault();
    if (form.dataset.oulaiCopyState === 'sending') return;
    form.dataset.oulaiCopyState = 'sending';
    setCopyStatus(form, 'sending', 'Submitting inquiry and confirming the assigned sales copy…');
    sendAssignedCopy(buildPayload(form)).then(function () {
      form.dataset.oulaiCopyState = 'confirmed';
      setCopyStatus(form, 'confirmed', 'Assigned sales copy confirmed. Submitting the main inquiry…');
    }).catch(function () {
      form.dataset.oulaiCopyState = 'failed';
      setCopyStatus(form, 'failed', 'Assigned sales copy could not be confirmed. The main inquiry will still be submitted.');
    }).then(function () { continueNativeSubmit(form, event.submitter); });
  }

  window.__oulaiBuildInquiryPayloadFromForm = buildPayload;
  window.__oulaiSendAssignedCopy = sendAssignedCopy;
  document.addEventListener('submit', handleSubmit, true);
})();

